import { Component, OnInit } from '@angular/core';
import { AuthFacade } from './auth/+store/auth.facade';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { environment } from '../environments/environment';
import { getAnalytics } from 'firebase/analytics';
import { getFirebaseApp } from './firebase';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { AppFacade } from './+store/app/app.facade';

@Component({
  selector: 'portals-patient-root',
  template: `<nb-layout>
    <nb-layout-column class="no-padding">
      <router-outlet></router-outlet>
    </nb-layout-column>
  </nb-layout>`,
  styles: [
    `
      nb-layout-column {
        height: 100dvh;
        overflow: auto;
      }
    `
  ]
})
export class AppComponent implements OnInit {
  constructor(
    private authFacade: AuthFacade,
    private gtm: Angulartics2GoogleTagManager,
    private appFacade: AppFacade
  ) {
    // Initialize Firebase
    const app = getFirebaseApp();
    if (environment.production) {
      this.gtm.startTracking();
      if (app) {
        try {
          getAnalytics(app);
        } catch (err) {
          console.warn('Firebase Analytics unavailable', err);
        }
      }
    }
  }

  ngOnInit() {
    this.appFacade.loadApp();
  }
}
